import styled from '@emotion/styled';
import { Radio } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const RadioCard = styled(Radio)`
  &.ant-radio-wrapper {
    padding: 8px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    &-checked {
      border-color: var(--fett-app-primary-color);
    }
    > span + span {
      color: rgba(0, 0, 0, 0.85);
    }
  }
`;

/**
 * 需要搭配 Radio.Button 使用
 */
export const GreyRadioGroup = styled(Radio.Group)`
  background-color: #f0f0f0;
  padding: 4px 6px;
  > label.ant-radio-button-wrapper {
    height: auto;
    line-height: 2.2em;
    background: none;
    border: none;
    border-width: 0;
    border-radius: 0;
    border-color: red;
    &::before,
    &::after {
      display: none;
    }
    > .ant-radio-button > input {
      opacity: 0 !important;
      outline: none;
      visibility: hidden;
    }
    &.ant-radio-button-wrapper-checked {
      background: #fff;
    }
  }
`;
